/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { teamsMemberDeleteAction } from 'src/reducers/teams/action'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { CoreButton } from 'src/components/core'
import { useSelector } from 'react-redux'
const DeleteMember = props => {
  const { entity, dispatch, classes } = props
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )

  const handleDeleteMember = () => {
    const teamsId = collectionSettings.teams.find(x => x.default === true).id
    dispatch(
      teamsMemberDeleteAction(teamsId, entity.id, () => {
        dispatch(messageBoxHideAction())
      }),
    )
  }

  const handleCloseModal = () => {
    dispatch(messageBoxHideAction())
  }

  return (
    <div className={classes.modal}>
      <div className={classes.modalContent}>
        <Typography className={classes.modalContent__header__text}>
          Are you sure you want to delete the learner?{' '}
        </Typography>

        <div className={classes.modalContent__buttons}>
          <CoreButton
            variant="text"
            color="secondary"
            size="small"
            onClick={() => handleCloseModal()}
          >
            Cancel
          </CoreButton>
          <CoreButton
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleDeleteMember()}
          >
            Delete
          </CoreButton>
        </div>
      </div>
    </div>
  )
}
export default withStyles(styles)(DeleteMember)
